export const dashboardConfig = {
  sections: {
    kpis: {
      enabled: true,
      title: 'Key Performance Indicators'
    },
    spendingTrends: {
      enabled: true,
      title: 'Spending Trends'
    },
    issueDistribution: {
      enabled: true,
      title: 'Issue Distribution'
    },
    efficiency: {
      enabled: true,
      title: 'Response Efficiency'
    },
    priorityMatrix: {
      enabled: true,
      title: 'Priority Matrix'
    },
    storePerformance: {
      enabled: true,
      title: 'Store Performance'
    },
    staffPerformance: {
      enabled: true,
      title: 'Staff Performance'
    }
  }
}; 